import { useTagList, useUnitList } from 'context/Store';

export default function useAccessoryData() {
	const tags = useTagList();
	const units = useUnitList();

	return {
		tags,
		units,
	};
}

export type AccessoryDetailData = ReturnType<typeof useAccessoryData>;
